export default __webpack_public_path__ + "static/media/overview_js_en.c3c84362.png";